import { useCopyToClipboard } from '@/lib/clipboard';
import { ComponentProps, ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { Check } from 'lucide-react';

export type CopyContainerProps = ComponentProps<'div'> & {
  value: string | number;
  label?: string;
};

export const CopyContainer = ({ children, value, label, ...rest }: CopyContainerProps) => {
  const [copy, isCopied] = useCopyToClipboard(() => String(value), 3000);

  return (
    <Tooltip open={isCopied ? true : undefined}>
      <TooltipTrigger onClick={() => copy()}>
        <div {...rest} className="">
          {children}
        </div>
      </TooltipTrigger>
      <TooltipContent side="right">
        {isCopied ? (
          <div className="flex items-center gap-x-2">
            <Check className="h-4 w-4" />
            Copied {label} to clipboard
          </div>
        ) : (
          `Copy ${label} to clipboard`
        )}
      </TooltipContent>
    </Tooltip>
  );
};
